import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { OptimisticState } from '../../middleware/optimistic/optimistic-updates';

const initialState: OptimisticState = {
  pending: {},
  rollbackData: {}
};

const optimisticSlice = createSlice({
  name: 'optimistic',
  initialState,
  reducers: {
    setPending: (state, action: PayloadAction<{ key: string; data: any }>) => {
      const { key, data } = action.payload;
      state.pending[key] = data;
    },
    clearPending: (state, action: PayloadAction<string>) => {
      const key = action.payload;
      delete state.pending[key];
      delete state.rollbackData[key];
    },
    saveRollbackData: (state, action: PayloadAction<{ key: string; data: any }>) => {
      const { key, data } = action.payload;
      state.rollbackData[key] = data;
    },
    restore: (state, action: PayloadAction<{ key: string; data: any }>) => {
      const { key, data } = action.payload;
      state.pending[key] = data;
    }
  }
});

export const { setPending, clearPending, saveRollbackData, restore } = optimisticSlice.actions;
export default optimisticSlice.reducer;
